module.exports = __webpack_public_path__ + "static/media/back_arrow.d3626495.svg";